import { render, staticRenderFns } from "./TCIActivation.vue?vue&type=template&id=19bd3ff5&"
import script from "./TCIActivation.vue?vue&type=script&lang=js&"
export * from "./TCIActivation.vue?vue&type=script&lang=js&"
import style0 from "./TCIActivation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports